import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthenticationApiService } from '@warema/shared/authentication/api';
import { BaseLeadcloudUrlEnvironment, ENVIRONMENT } from '@warema/shared/models';
import { SharedSvgModule } from '@warema/shared/svg';
import { DashboardBannerItem, WaremaPlusAccessStep } from '@warema/warema-plus/models';
import { WaremaButton } from '@warema/warema-ui-angular';

@Component({
    selector: 'warema-dashboard-public',
    templateUrl: './dashboard-public.component.html',
    styleUrls: ['./dashboard-public.component.scss'],
    imports: [TranslatePipe, SharedSvgModule, WaremaButton],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardPublicComponent {
    private readonly _environment = inject<BaseLeadcloudUrlEnvironment>(ENVIRONMENT);
    private readonly _authenticationApiService = inject(AuthenticationApiService);

    public readonly bannerUrl = `${this._environment.baseLeadCloudUrl}/images/dashboard/public_dashboard_banner_background.png`;

    public readonly bannerItems: Array<DashboardBannerItem> = [
        new DashboardBannerItem('icons/medal', 29, 41, 'INDIVIDUAL', 'DASHBOARD_PUBLIC.INDIVIDUAL_TEXT'),
        new DashboardBannerItem('icons/icon_safety', 29, 41, 'SECURE', 'DASHBOARD_PUBLIC.SECURE_TEXT'),
        new DashboardBannerItem('icons/icon_mail', 34, 21, 'CONTACT', 'DASHBOARD_PUBLIC.CONTACT_TEXT'),
        new DashboardBannerItem('icons/icon_free', 48, 42, 'FREE_OF_CHARGE', 'DASHBOARD_PUBLIC.FREE_OF_CHARGE_TEXT'),
    ];

    public readonly waremaPlusAccessSteps: Array<WaremaPlusAccessStep> = [
        new WaremaPlusAccessStep(1, 'icons/icon_registration_step1', 98, 82, 'DASHBOARD_PUBLIC.STEPS.ONE'),
        new WaremaPlusAccessStep(2, 'icons/icon_registration_step2', 98, 82, 'DASHBOARD_PUBLIC.STEPS.TWO'),
        new WaremaPlusAccessStep(3, 'icons/icon_registration_step3', 98, 82, 'DASHBOARD_PUBLIC.STEPS.THREE'),
    ];

    public async login(): Promise<void> {
        await this._authenticationApiService.login();
    }

    public async register(): Promise<void> {
        await this._authenticationApiService.register();
    }

    public openRegistrationInstructions(): void {
        window.open('https://warema.slidepresenter.com/presentations/42e881e6-4256-4e0b-b347-afe57c7e7d87', '_blank');
    }

    public openPasswordResetInstructions(): void {
        window.open('https://warema.slidepresenter.com/presentations/209d54fd-503a-4c85-8c17-8c7d56567d4e', '_blank');
    }
}
